/**
 * DE-1656: a share's e-mail is sent at once, or waits until the documents' previews are ready (at most 30 minutes).
 * DE-1723: the share is made in the background; when it is still being made after 2 minutes, the dialog says so
 * ('pending') and the history shows the outcome when it comes (postShare.js).
 */

export const DELIVERY_WAITING = 'waiting';
export const DELIVERY_PENDING = 'pending';

/** The message shown after sharing; an older backend that doesn't say has sent the e-mail. */
export const shareDeliveryMessage = (t, delivery) => {
    if (delivery === DELIVERY_WAITING) {
        return t('shareEmailWaiting', 'Delt. E-posten sendes når forhåndsvisningene er klare, senest om 30 minutter.');
    }
    if (delivery === DELIVERY_PENDING) {
        return t('shareDeliveryPending', 'Delingen er ikke ferdig ennå. Se historikken for status.');
    }
    return t('shareEmailSent', 'Delt. E-posten er sendt.');
};

/**
 * A history row's e-mail status: Sendes while the share is made, Venter while it waits for the previews, else Sendt or
 * Feilet by whether it was sent. The e-mail status decides, because shares from before DE-1656 are all SENT, also
 * those whose e-mail failed. The backend shows a share lost while being made as FAILED.
 */
export const deliveryStatusText = (t, row) => {
    if (row.deliveryStatus === 'SENDING') return t('shareEmailStatusSending', 'Sendes');
    if (row.deliveryStatus === 'WAITING') return t('shareEmailStatusWaiting', 'Venter');
    return row.emailStatus
        ? t('shareEmailStatusSent', 'Sendt')
        : t('shareEmailStatusFailed', 'Feilet');
};
